<mat-toolbar class="default__header">
  <mat-toolbar-row>
    <button mat-icon-button class="icone__menu" (click)="toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <img src="./../../../assets/images/new-logo-bmg.svg" alt="Logo BMG" width="200px" routerLink='/home'>
    <span class="header__spacer"></span>
    <button mat-raised-button *ngIf="hasPermission" type="submit" class="button orange__button button__proposal"
      style="margin-right: 1rem;" (click)="redirectToProposal()">
      Faça sua Proposta
    </button>
    <app-doubts-menu #notification email={{loadEnviromentsObj?.emailHub?.email}}></app-doubts-menu>
    <app-notification #notification></app-notification>
    <mat-card class="card__email">
      <div>
        <div mat-card-avatar class="avatar__account"></div>
        <mat-card-title class="title">
          {{email}}
        </mat-card-title>
      </div>
    </mat-card>
    <div>
      <button mat-button (click)="perfil()">
        <span>Meu Perfil</span>
      </button>
      <button mat-button (click)="logOut()">
        <img src="../../../assets/icons/icon-exittoapp.svg">
        <span>Sair</span>
      </button>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
